import { render, staticRenderFns } from "./Izvestaj.vue?vue&type=template&id=6ab660d7&scoped=true"
import script from "./Izvestaj.vue?vue&type=script&lang=js"
export * from "./Izvestaj.vue?vue&type=script&lang=js"
import style0 from "./Izvestaj.vue?vue&type=style&index=0&id=6ab660d7&prod&lang=css"
import style1 from "./Izvestaj.vue?vue&type=style&index=1&id=6ab660d7&prod&scoped=true&lang=css"
import style2 from "./Izvestaj.vue?vue&type=style&index=2&id=6ab660d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab660d7",
  null
  
)

export default component.exports